import styled from "styled-components";

const ButtonNormal = styled.button`
    display: inline-block;
    border: none;
    border-radius: 30px;
    padding: 0 35px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #66ccff;
    color: #ffffff;
    font-size: 1.2rem;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    transition: 0.2s;

    :hover {
        background-color: #55aadd;
    }

    :disabled {
        color: #ffffff;
        background-color: ${p => p.theme.colors?.bgDisabled};
    }

    :active {
        background-color: #3388ee;
    }
    
`;

export default ButtonNormal;